import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { cn } from '@/lib/utils';

interface InsightMarkdownProps {
  content: string;
  className?: string;
}

// remark-gfm enables GitHub-flavored markdown extensions: tables, strikethrough,
// task lists, autolinks. The model's prompts already instruct it to use tables
// for per-team / per-product comparisons; without this plugin those tables
// rendered as a wall of literal pipes and dashes.
const REMARK_PLUGINS = [remarkGfm];

export function InsightMarkdown({ content, className }: Readonly<InsightMarkdownProps>) {
  return (
    <div
      className={cn(
        'prose prose-sm md:prose-base max-w-none',
        'dark:prose-invert',
        'prose-headings:mt-3 prose-headings:mb-1',
        'prose-p:my-1 prose-ul:my-1 prose-li:my-0',
        // Constrain table breakout: keep the table inside the bubble width and
        // let it scroll horizontally when columns are too wide for the viewport,
        // rather than overflowing the page.
        'prose-table:my-2 prose-table:block prose-table:overflow-x-auto prose-table:max-w-full',
        'prose-th:px-2 prose-th:py-1 prose-td:px-2 prose-td:py-1',
        className,
      )}
    >
      <ReactMarkdown remarkPlugins={REMARK_PLUGINS}>{content}</ReactMarkdown>
    </div>
  );
}
